import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import { Replay } from '@sentry/replay'
import { version } from './../package.json'

export default ({ app, $config }) => {
  const sentryEnabled =
    $config.sentryEnabled === true || $config.sentryEnabled === 'true'

  if (!sentryEnabled) {
    return
  }

  Sentry.init({
    Vue,
    dsn: $config.sentryDsn,
    tunnel: $config.sentryTunnel,
    environment: $config.sentryEnv || 'dev',

    release: version,
    debug: false,

    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(app.router),
      }),

      new Replay(),
    ],

    tracesSampleRate: 1.0,

    // Записывать 10% обычных сессий
    replaysSessionSampleRate: 0.1,

    // При ошибке записывать 100%
    replaysOnErrorSampleRate: 1.0,
  })
}
